// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","cls1":"_2-jzv","cls2":"_1uBNI"};